export default {
  firebaseConfig: {
    apiKey: "AIzaSyBBFY_3tjHk-E-0DJ_IiXXHyP1qzTjDpS8",
    authDomain: "chinese-ocr-274418.firebaseapp.com",
    databaseURL: "https://chinese-ocr-274418.firebaseio.com",
    projectId: "chinese-ocr-274418",
    storageBucket: "chinese-ocr-274418.appspot.com",
    messagingSenderId: "1074125963418",
    appId: "1:1074125963418:web:34ff548ea167df9d945f23"
  }
}
